/** @jsx jsx */
import { jsx, css } from '@emotion/core' // eslint-disable-line
import React, { Component } from 'react' // eslint-disable-line
import { observer } from 'mobx-react'
import * as dayjs from 'dayjs'

import { Table, Icon, Input, Button } from 'antd'
import { machineStore } from '../../../store/list/MachineModel'

import { GeneralStyles } from '../../../styles/general'
import BusinessStatus from '../../../business/status'
import StatusTag from '../../../components/StatusTag'
import MachineViewer from '../../../components/business/MachineViewer'
import MachineCreateDrawer from '../../../components/business/MachineCreateDrawer'
import UserViewer from '../../../components/business/UserViewer'
import MachineListAction from './MachineListAction'

import { buildListPage, LIST_PAGE_TYPES } from '../../list_builder'

const { Search } = Input

interface IMachineListProps { }

interface IMachineListState {
  searchLoading: boolean
}

interface MachineList {
  props: IMachineListProps
  state: IMachineListState
}

const pageColumns = [
  {
    title: '序号',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '机器Id',
    dataIndex: 'machine_id',
    key: 'machine_id',
    render: (text: any) => <MachineViewer machine_id={text} />,
  },
  {
    title: '用户',
    dataIndex: 'uid',
    key: 'uid',
    render: (text: any) => <UserViewer uid={text} />,
  },
  {
    title: '价格',
    dataIndex: 'price',
    key: 'price',
  },
  {
    title: 'GPU数量',
    dataIndex: 'unit',
    key: 'unit',
  },
  {
    title: 'GPU使用数量',
    dataIndex: 'used_unit',
    key: 'used_unit',
  },
  {
    title: 'GPU锁定数量',
    dataIndex: 'locked_unit',
    key: 'locked_unit',
  },
  {
    title: '试用次数',
    dataIndex: 'trial_times',
    key: 'trial_times',
  },
  {
    title: '开始时间',
    dataIndex: 'start_rent_time',
    key: 'start_rent_time',
    render: (text: any) => (
      <span>{dayjs(text).format('YYYY-MM-DD HH:mm:ss')}</span>
    ),
  },
  {
    title: '状态',
    key: 'status',
    dataIndex: 'status',
    render: (status: any, item: any) => (
      <span>
        <StatusTag item={item} status={status} config={BusinessStatus.machine} />
      </span>
    ),
  },
  {
    title: '操作',
    key: 'action',
    render: (text: any, record: any) => {
      return <MachineListAction text={text} record={record} />
    },
  },
]

@observer
class MachineList extends Component {
  constructor(props: IMachineListProps) {
    super(props)

    this.state = {
      searchLoading: false,
    }
  }

  componentDidMount() {
    machineStore.loadPageList()
  }

  reloadList = () => {
    machineStore.reloadCurrentPage()
  }

  handleTableChange = (pagination: any) => {
    if (pagination['current'] === machineStore.listResponse.current) {
      return
    }

    machineStore.changePage(pagination['current'])
  }

  searchMachineId = (machineId: any) => {
    this.setState((preState, props) => ({
      searchLoading: true,
    }))
    machineStore
      .loadPageList({
        machine_id: machineId,
      })
      .then(() => {
        this.setState((preState, props) => ({
          searchLoading: false,
        }))
      })
  }

  render() {
    // const { pageList } = this.state
    const listResponse = machineStore.listResponse
    const pageList = listResponse.list.map((item: any) => {
      return {
        key: item['machine_id'],
        ...item,
      }
    })
    const loadState = machineStore.listError

    return (
      <div className="general-page" css={GeneralStyles['general-page']}>
        <div css={GeneralStyles['page-head']}>
          <div className="head-title">
            <span className="title-text"><Icon type="cluster" /> 机器列表</span>
          </div>
        </div>
        <div css={GeneralStyles['page-content']}>
          <div css={GeneralStyles['content-pane']} className="content-pane">
            <div css={GeneralStyles['simple-pane-inner']}>
              <div className="simple-line-item">
                <MachineCreateDrawer text="创建机器" icon="plus"/>
              </div>
              <div className="simple-line-item">
                <Button icon="reload" onClick={this.reloadList}/>
              </div>
              <div className="simple-line-item">
                <Search
                  placeholder="输入机器ID"
                  loading={this.state.searchLoading}
                  onSearch={this.searchMachineId}
                />
              </div>
            </div>
          </div>
          <div css={GeneralStyles['content-pane']} className="content-pane">
            <Table
              columns={pageColumns}
              rowKey={(record: any) => record.machine_id}
              dataSource={pageList}
              pagination={{
                current: listResponse.current,
                total: listResponse.total,
                pageSize: listResponse.size,
              }}
              loading={loadState.state === 'loading'}
              onChange={this.handleTableChange}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default buildListPage(LIST_PAGE_TYPES.MACHINE, MachineList)
